// extracted by mini-css-extract-plugin
export default {"customersView":"CustomersView_customersView__8vyrK"};